import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { IRadioProps } from '.'

type C = React.ComponentType<IRadioProps>

function withRedux(Component: C) {
  return function({ input, meta, ...rest }: WrappedFieldProps & IRadioProps) {
    return (
      <Component
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        onBlur={input.onBlur}
        errorMsg={meta.touched && meta.error}
        warningMsg={meta.touched && meta.warning}
        isValidating={meta.asyncValidating}
        {...rest}
      />
    )
  }
}

export default withRedux
